<template>
  <div class="w-full">
    <section>
      <SearchAndFilter v-model="queryString" />
      <ContentSectionLoader v-show="loading" />
      <Transition name="fade">
        <div
          v-if="!loading"
          class="table-responsive"
        >
          <table
            style="overflow: hidden;"
            class="table w-full table-data min-w-table"
          >
            <thead>
              <tr>
                <th v-text="'Member'" />
                <th v-text="'Payment Details'" />
                <th v-text="'Reason'" />
                <th v-text="'Created At'" />
                <th v-text="'Status'" />
              </tr>
            </thead>
            <tbody v-if="refunds.data.length">
              <tr
                is="RefundRow"
                v-for="refund in refunds.data"
                :key="refund.uuid"
                :refund="refund"
              />
            </tbody>
            <tbody v-else>
              <tr>
                <td
                  class="text-center"
                  colspan="6"
                  v-text="'No results'"
                />
              </tr>
            </tbody>
          </table>
          <Pagination
            :on-change="updatePage"
            :pagination="pagination"
          />
        </div>
      </Transition>
    </section>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import { mapActions, mapState } from 'vuex'
import Pagination from 'Base/Resources/assets/js/components/Pagination'
import SearchAndFilter from './SearchAndFilter'
import RefundRow from './RefundRow'

export default {
  name: 'Refunds',
  components: {
    SearchAndFilter,
    Pagination,
    RefundRow,
  },
  data() {
    return {
      loading: true,
      queryString: {
        search: '',
        page: 1,
        filter: 'all',
      },
    }
  },
  computed: {
    ...mapState({
      refunds: state => state.payments.refunds,
    }),
    pagination() {
      return this.refunds.meta.pagination
    },
    fetchUrl() {
      return new URI('').setSearch(this.queryString).toString()
    },
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        history.pushState(null, null, this.fetchUrl)

        this.fetch()
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    this.fetch()
  },
  methods: {
    ...mapActions([
      'paymentsGetRefunds',
    ]),
    updatePage(page) {
      this.fetch(page)
    },
    fetch() {
      this.loading = true

      this.queryString.include = 'payment.payer'

      this.paymentsGetRefunds(this.queryString).then(() => {
        this.loading = false
      })
    },
    handleQueryUpdate({ search, filter }) {
      this.fetch()
    },
  },
}
</script>
